import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Trocar modelo de folha?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary" }, " As informações já preenchidas nesta folha serão apagadas. ")
], -1)
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

/**
 * RF-07 (#2115) — confirmação obrigatória sempre que há alguma linha em uso (RN-03):
 * trocar o modelo reconstrói as colunas e descarta o histórico de desfazer junto com a
 * estrutura antiga, e essa troca não é desfazível. Padrão visual do modal de troca de
 * modelo do protótipo (RF-11): `me-card` central, título, descrição, "Cancelar" +
 * confirmação.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceSwitchTemplateModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[480px]",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "switch-template-cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: "Trocar modelo",
          class: "bg-primary30",
          width: "160px",
          height: "40px",
          "data-testid": "switch-template-confirm-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})